export function RegisterHeader({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <div className="text-center mb-6">
      <h1 className="text-2xl font-bold">
        {title}
      </h1>
      <p className="mt-2 text-sm opacity-50">
        {subtitle}
      </p>
    </div>
  );
}
